(function () {
    'use strict';
    module.exports =changeColor;

    function changeColor(val) {
        let vm = this;
        vm.currentCanvas.freeDrawingBrush.color = val;
    }

})();